module.exports = __webpack_public_path__ + "img/1alB-d-duh.f0cdf683.jpg";